module.exports = __webpack_public_path__ + "static/media/YF78_3.0835ac7a.jpg";